module.exports = __webpack_public_path__ + "static/media/cross.63881dbc.svg";